/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AbpPtwExceptionHttpResponseModel,
  CalibrationDataOverviewDto,
  CreateQaEquipmentRtSystemDto,
  HistoryDto,
  ODataPostProcessedResultsOfEquipmentTypeCatalogDto,
  ODataPostProcessedResultsOfQaEquipmentRtSystemDto,
  ProblemDetails,
  QaEquipmentCatalogDto,
  QaEquipmentRtSystemDto,
} from '../models/index';
import {
    AbpPtwExceptionHttpResponseModelFromJSON,
    AbpPtwExceptionHttpResponseModelToJSON,
    CalibrationDataOverviewDtoFromJSON,
    CalibrationDataOverviewDtoToJSON,
    CreateQaEquipmentRtSystemDtoFromJSON,
    CreateQaEquipmentRtSystemDtoToJSON,
    HistoryDtoFromJSON,
    HistoryDtoToJSON,
    ODataPostProcessedResultsOfEquipmentTypeCatalogDtoFromJSON,
    ODataPostProcessedResultsOfEquipmentTypeCatalogDtoToJSON,
    ODataPostProcessedResultsOfQaEquipmentRtSystemDtoFromJSON,
    ODataPostProcessedResultsOfQaEquipmentRtSystemDtoToJSON,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
    QaEquipmentCatalogDtoFromJSON,
    QaEquipmentCatalogDtoToJSON,
    QaEquipmentRtSystemDtoFromJSON,
    QaEquipmentRtSystemDtoToJSON,
} from '../models/index';

export interface ActivateNewCalibrationDataRequest {
    id: string;
}

export interface CreateQaEquipmentRtSystemRequest {
    createQaEquipmentRtSystemDto?: CreateQaEquipmentRtSystemDto;
}

export interface DeleteQaEquipmentRtSystemRequest {
    id: string;
}

export interface GetQaEquipmentCalibrationDataRequest {
    id: string;
}

export interface GetQaEquipmentHistoryRequest {
    id: string;
}

export interface GetQaEquipmentOptionsRequest {
    $filter?: string;
    $search?: string;
    $top?: number;
    $skip?: number;
    $orderby?: string;
}

export interface GetQaEquipmentRtSystemRequest {
    id: string;
}

export interface GetQaEquipmentRtSystemListRequest {
    $filter?: string;
    $search?: string;
    $top?: number;
    $skip?: number;
    $orderby?: string;
}

export interface GetQaEquipmentTemplateRequest {
    optionId: string;
}

export interface UpdateQaEquipmentRtSystemRequest {
    id: string;
    createQaEquipmentRtSystemDto?: CreateQaEquipmentRtSystemDto;
}

export interface ValidateQaEquipmentRtSystemRequest {
    createQaEquipmentRtSystemDto?: CreateQaEquipmentRtSystemDto;
}

/**
 * 
 */
export class QaEquipmentApi extends runtime.BaseAPI {

    /**
     */
    async activateNewCalibrationDataRaw(requestParameters: ActivateNewCalibrationDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling activateNewCalibrationData.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/qa-equipment/{id}/activate-calibration-data`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async activateNewCalibrationData(requestParameters: ActivateNewCalibrationDataRequest, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.activateNewCalibrationDataRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<void>(response, errorHandlers);
    }

    /**
     * Adds a new entity
     */
    async createQaEquipmentRtSystemRaw(requestParameters: CreateQaEquipmentRtSystemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<QaEquipmentRtSystemDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/qa-equipment`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateQaEquipmentRtSystemDtoToJSON(requestParameters.createQaEquipmentRtSystemDto),
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => QaEquipmentRtSystemDtoFromJSON(jsonValue));
    }

    /**
     * Adds a new entity
     */
    async createQaEquipmentRtSystem(requestParameters: CreateQaEquipmentRtSystemRequest = {}, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.createQaEquipmentRtSystemRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<QaEquipmentRtSystemDto>(response, errorHandlers);
    }

    /**
     * Deletes the entity with the given id.
     */
    async deleteQaEquipmentRtSystemRaw(requestParameters: DeleteQaEquipmentRtSystemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteQaEquipmentRtSystem.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/qa-equipment/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes the entity with the given id.
     */
    async deleteQaEquipmentRtSystem(requestParameters: DeleteQaEquipmentRtSystemRequest, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.deleteQaEquipmentRtSystemRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<void>(response, errorHandlers);
    }

    /**
     */
    async getAllQaEquipmentCatalogRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<QaEquipmentCatalogDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/qa-equipment/catalog`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(QaEquipmentCatalogDtoFromJSON));
    }

    /**
     */
    async getAllQaEquipmentCatalog(errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.getAllQaEquipmentCatalogRaw(initOverrides);
        return this.configuration.handleFunction<Array<QaEquipmentCatalogDto>>(response, errorHandlers);
    }

    /**
     */
    async getQaEquipmentCalibrationDataRaw(requestParameters: GetQaEquipmentCalibrationDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CalibrationDataOverviewDto>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getQaEquipmentCalibrationData.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/qa-equipment/{id}/calibration-data`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => CalibrationDataOverviewDtoFromJSON(jsonValue));
    }

    /**
     */
    async getQaEquipmentCalibrationData(requestParameters: GetQaEquipmentCalibrationDataRequest, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.getQaEquipmentCalibrationDataRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<CalibrationDataOverviewDto>(response, errorHandlers);
    }

    /**
     */
    async getQaEquipmentHistoryRaw(requestParameters: GetQaEquipmentHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<HistoryDto>>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getQaEquipmentHistory.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/qa-equipment/{id}/history`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(HistoryDtoFromJSON));
    }

    /**
     */
    async getQaEquipmentHistory(requestParameters: GetQaEquipmentHistoryRequest, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.getQaEquipmentHistoryRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<Array<HistoryDto>>(response, errorHandlers);
    }

    /**
     */
    async getQaEquipmentOptionsRaw(requestParameters: GetQaEquipmentOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ODataPostProcessedResultsOfEquipmentTypeCatalogDto>> {
        const queryParameters: any = {};

        if (requestParameters.$filter !== undefined) {
            queryParameters['$filter'] = requestParameters.$filter;
        }

        if (requestParameters.$search !== undefined) {
            queryParameters['$search'] = requestParameters.$search;
        }

        if (requestParameters.$top !== undefined) {
            queryParameters['$top'] = requestParameters.$top;
        }

        if (requestParameters.$skip !== undefined) {
            queryParameters['$skip'] = requestParameters.$skip;
        }

        if (requestParameters.$orderby !== undefined) {
            queryParameters['$orderby'] = requestParameters.$orderby;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/qa-equipment/options`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => ODataPostProcessedResultsOfEquipmentTypeCatalogDtoFromJSON(jsonValue));
    }

    /**
     */
    async getQaEquipmentOptions(requestParameters: GetQaEquipmentOptionsRequest = {}, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.getQaEquipmentOptionsRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<ODataPostProcessedResultsOfEquipmentTypeCatalogDto>(response, errorHandlers);
    }

    /**
     * Returns one entity for detail view.
     */
    async getQaEquipmentRtSystemRaw(requestParameters: GetQaEquipmentRtSystemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<QaEquipmentRtSystemDto>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getQaEquipmentRtSystem.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/qa-equipment/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => QaEquipmentRtSystemDtoFromJSON(jsonValue));
    }

    /**
     * Returns one entity for detail view.
     */
    async getQaEquipmentRtSystem(requestParameters: GetQaEquipmentRtSystemRequest, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.getQaEquipmentRtSystemRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<QaEquipmentRtSystemDto>(response, errorHandlers);
    }

    /**
     * Returns a list of entities for grid view.
     */
    async getQaEquipmentRtSystemListRaw(requestParameters: GetQaEquipmentRtSystemListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ODataPostProcessedResultsOfQaEquipmentRtSystemDto>> {
        const queryParameters: any = {};

        if (requestParameters.$filter !== undefined) {
            queryParameters['$filter'] = requestParameters.$filter;
        }

        if (requestParameters.$search !== undefined) {
            queryParameters['$search'] = requestParameters.$search;
        }

        if (requestParameters.$top !== undefined) {
            queryParameters['$top'] = requestParameters.$top;
        }

        if (requestParameters.$skip !== undefined) {
            queryParameters['$skip'] = requestParameters.$skip;
        }

        if (requestParameters.$orderby !== undefined) {
            queryParameters['$orderby'] = requestParameters.$orderby;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/qa-equipment`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => ODataPostProcessedResultsOfQaEquipmentRtSystemDtoFromJSON(jsonValue));
    }

    /**
     * Returns a list of entities for grid view.
     */
    async getQaEquipmentRtSystemList(requestParameters: GetQaEquipmentRtSystemListRequest = {}, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.getQaEquipmentRtSystemListRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<ODataPostProcessedResultsOfQaEquipmentRtSystemDto>(response, errorHandlers);
    }

    /**
     */
    async getQaEquipmentTemplateRaw(requestParameters: GetQaEquipmentTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateQaEquipmentRtSystemDto>> {
        if (requestParameters.optionId === null || requestParameters.optionId === undefined) {
            throw new runtime.RequiredError('optionId','Required parameter requestParameters.optionId was null or undefined when calling getQaEquipmentTemplate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/qa-equipment/template/{optionId}`.replace(`{${"optionId"}}`, encodeURIComponent(String(requestParameters.optionId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => CreateQaEquipmentRtSystemDtoFromJSON(jsonValue));
    }

    /**
     */
    async getQaEquipmentTemplate(requestParameters: GetQaEquipmentTemplateRequest, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.getQaEquipmentTemplateRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<CreateQaEquipmentRtSystemDto>(response, errorHandlers);
    }

    /**
     * Updates an entity, if existing
     */
    async updateQaEquipmentRtSystemRaw(requestParameters: UpdateQaEquipmentRtSystemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<QaEquipmentRtSystemDto>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateQaEquipmentRtSystem.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/qa-equipment/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateQaEquipmentRtSystemDtoToJSON(requestParameters.createQaEquipmentRtSystemDto),
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => QaEquipmentRtSystemDtoFromJSON(jsonValue));
    }

    /**
     * Updates an entity, if existing
     */
    async updateQaEquipmentRtSystem(requestParameters: UpdateQaEquipmentRtSystemRequest, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.updateQaEquipmentRtSystemRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<QaEquipmentRtSystemDto>(response, errorHandlers);
    }

    /**
     * Validates an entity without adding or updating it.
     */
    async validateQaEquipmentRtSystemRaw(requestParameters: ValidateQaEquipmentRtSystemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/qa-equipment/validate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateQaEquipmentRtSystemDtoToJSON(requestParameters.createQaEquipmentRtSystemDto),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }

    /**
     * Validates an entity without adding or updating it.
     */
    async validateQaEquipmentRtSystem(requestParameters: ValidateQaEquipmentRtSystemRequest = {}, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.validateQaEquipmentRtSystemRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<void>(response, errorHandlers);
    }

}
